import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { organization, branding } from "../../config";

export default function HeaderSlidesPublic() {
  const [slides, setSlides] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [tagline, setTagline] = useState({ text: "" });

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const res = await axios.get("/api/public/slides");
        setSlides(res.data.content || []);
      } catch (error) {
        console.error("Error fetching slides:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSlides();
  }, []);

  useEffect(() => {
    axios.get("/api/public/tagline").then((res) => {
      setTagline(res.data.content);
    });
  }, []);

  // Auto-advance slides every 5 seconds
  useEffect(() => {
    if (slides.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length, currentIndex]); // Reset timer when currentIndex changes

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % slides.length);
  };

  if (loading) {
    return (
      <main
        style={{
          fontFamily: "'Montserrat', sans-serif",
          paddingTop: "80px",
          paddingBottom: "0px",
          height: "70vh",
          minHeight: "600px",
          position: "relative",
          backgroundColor: "#333",
          marginTop: "-80px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          className="container text-center"
          style={{
            position: "relative",
            zIndex: 2,
            color: "white",
          }}
        >
          <p>Loading...</p>
        </div>
      </main>
    );
  }

  if (slides.length === 0) {
    // Fallback if no slides
    return (
      <main
        style={{
          fontFamily: "'Montserrat', sans-serif",
          paddingTop: "80px",
          paddingBottom: "0px",
          height: "70vh",
          minHeight: "600px",
          position: "relative",
          backgroundColor: "#333",
          marginTop: "-80px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.45)",
            zIndex: 1,
          }}
        />
        <div
          className="container text-center"
          style={{
            position: "relative",
            zIndex: 2,
            color: "white",
            textShadow: "2px 2px 6px rgba(0, 0, 0, 0.7)",
            maxWidth: "800px",
            margin: "0 auto",
          }}
        >
          <h1
            className="display-4 fw-bold mb-4"
            style={{
              letterSpacing: "1px",
              // textTransform: "uppercase",
            }}
          >
            {organization.name}
          </h1>
          <p className="lead fw-semibold mb-5">{tagline.text}</p>
        </div>
      </main>
    );
  }

  const currentSlide = slides[currentIndex];

  return (
    <main
      style={{
        fontFamily: "'Montserrat', sans-serif",
        paddingTop: "20px",
        paddingBottom: "0px",
        height: "70vh",
        minHeight: "600px",
        position: "relative",
        overflow: "hidden",
        marginTop: "-80px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Slides Container */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          transition: "transform 0.5s ease-in-out",
        }}
      >
        {slides.map((slide, index) => (
          <div
            key={index}
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: slide.image ? `url('${slide.image}')` : "none",
              backgroundColor: slide.image ? "transparent" : "#333",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              opacity: index === currentIndex ? 1 : 0,
              transition: "opacity 1s ease-in-out",
              zIndex: index === currentIndex ? 1 : 0,
            }}
          />
        ))}
      </div>

      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0, 0, 0, 0.475)",
          zIndex: 2,
        }}
      />

      {/* Content */}
      <div
        className="container text-center"
        style={{
          position: "relative",
          zIndex: 3,
          color: "white",
          textShadow: "2px 2px 6px rgba(0, 0, 0, 0.9)",
          maxWidth: "800px",
          margin: "0 auto",
        }}
      >
        <h1
          className="display-6 fw-bold mb-4"
          style={{
            letterSpacing: "1px",
            // textTransform: "uppercase",
          }}
        >
          {currentSlide.name || organization.name}
        </h1>
        <p className="lead fw-semibold mb-5">
          {currentSlide.description || tagline.text}
        </p>
        <div className="d-flex justify-content-center gap-3 flex-wrap">
          {currentSlide.link ? (
            <Link
              to={`/${currentSlide.link}`}
              className="btn btn-custom-filled btn-lg px-4 py-2"
            >
              {currentSlide.link_label || "Learn More"}
            </Link>
          ) : (
            <>
              <Link to="/events" className="btn btn-custom-filled px-4 py-2">
                View Events
              </Link>
              <Link
                to="/about"
                className="btn btn-custom-filled-light px-4 py-2"
              >
                Learn More
              </Link>
            </>
          )}
        </div>
      </div>

      {/* Navigation Arrows */}
      {/* {slides.length > 1 && (
        <>
          <button
            onClick={goToPrevious}
            style={{
              position: "absolute",
              left: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 4,
              backgroundColor: "rgba(255, 255, 255, 0.3)",
              border: "none",
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              color: "white",
              fontSize: "24px",
              transition: "background-color 0.3s",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.5)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.3)")
            }
            aria-label="Previous slide"
          >
            ‹
          </button>
          <button
            onClick={goToNext}
            style={{
              position: "absolute",
              right: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 4,
              backgroundColor: "rgba(255, 255, 255, 0.3)",
              border: "none",
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              color: "white",
              fontSize: "24px",
              transition: "background-color 0.3s",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.5)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.3)")
            }
            aria-label="Next slide"
          >
            ›
          </button>
        </>
      )} */}

      {/* Dot Indicators */}
      {slides.length > 1 && (
        <div
          style={{
            position: "absolute",
            bottom: "30px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 4,
            display: "flex",
            gap: "10px",
          }}
        >
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              style={{
                width: "12px",
                height: "12px",
                borderRadius: "50%",
                border: "2px solid white",
                backgroundColor:
                  index === currentIndex ? "white" : "transparent",
                cursor: "pointer",
                transition: "background-color 0.3s",
                padding: 0,
              }}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      )}
    </main>
  );
}
